var map;
// POI marker images
var blueMarkerImage = new google.maps.MarkerImage("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAA8FBMVEUAAAAAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8gAd8hFTEx+AAAAT3RSTlMAAQIDBAUGCAkKDxAREhcYICMkJSYqKywtLzg8RktMTVRVV1xeZGZpa21vcHF0e4KFmJulpqiqq62vsLLBxdPV2drc3uDi5u/x8/X3+fv9XSr9GgAAAXxJREFUGBmNwYt20kAUBdAz6CSo+MSk+KZWrFSrVUxVqqVoik2aev7/b3R5hyxmMkOyN5rUcDJbluVyNhkqtIunJWvlNEaLcUVLNcY2es6GuUZQf0GPRR8BekGvUw2/EwbM4bXLoDE84iuuZaNIqWh0zLUqRtMBjSKBkZY0pmjolRTFALXbBUWp4HpII8GGlMYQrtcUGSzHFBO4PlPswDKimMH1kyKCJaJYwlVSwKYoSrguKWBTFCVcOUUES0TxC65vFCksI4ovcL2hyGDJKPbhGtJIsCGh8QAutaIoBqgNCoqVQsNzGkUCIyloPENT74JrWRoB0U7GtYsePPYYtAcfXTGg0vA6YMBb+PUZ0EfAB3odIeQmvW4h6CM9PiHsDj3uYouvbDjBNvfYcB9bfafjB7ZL6XiEFqe0nKHNY1qeoI0654aVQqun3PAC7Xq/WSuuoYOXrL1CF9cvaVxpdLJP4x26if9Q3EBH7/nfEbrSOf/JNTrTh3l+qOHzF6NA/Jb4UYLwAAAAAElFTkSuQmCC", null, null, null, new google.maps.Size(32, 32)); // fa-map-marker medium blue
var itineraryColours = ["#f4c141", "#196d35", "#f48341", "#18456d", "#451d82", "#b5277a", "#b5273c", "#f44242", "#000000", "#FFFFFF"];
// Template for the popup info window with details of the map item
var contentTemplate =
    '<div>' +
    '<a href="[href]">' +
    '<img src="[src]" style="float:left; padding:8px;">' +
    '<div>' +
    '<p><b>[name]</b></p>' +
    '</div>' +
    '</a>' +
    '</div>';

initMap();

function initMap() {
    // Centre on Fraser Island
    map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: -25.2398212, lng: 153.1324073 },
        zoom: 9
    });

    // Show any place of interest locations.
    if (typeof poiLocations != 'undefined') {
        addMapPOIs(map, poiLocations, blueMarkerImage);
    }
    // Show itinerary route.
    if (typeof itineraries != 'undefined') {
        addMapItineraries(map, itineraries);
    }
}

// Add the given poi items to the map.
function addMapPOIs(map, locations, icon, labels) {

    // Enumerate all locations and add markers as appropriate.
    for (var i = 0; i < locations.length; i++) {
        var location = locations[i];

        if (location.latLng && location.latLng.lat && location.latLng.lng) {

            var content = contentTemplate.replace("[href]", location.url)
                .replace("[src]", location.imageMedia ? cleanMediaUrl(location.imageMedia.url) + "?anchor=center&mode=crop&width=64&height=64" : "")
                .replace("[name]", location.name);

            var infoWindow = new google.maps.InfoWindow({ maxWidth: 200 });

            // show a map marker for a POI
            var latLng = new google.maps.LatLng(location.latLng.lat, location.latLng.lng);

            var marker = new google.maps.Marker({
                position: latLng,
                icon: icon,
                label: labels ? labels[i % labels.length] : null,
                map: map
            });

            // Show the info window when the POI marker is clicked 
            google.maps.event.addListener(marker, 'click', (function (marker, content, infoWindow) {
                return function () {
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);
                    google.maps.event.addListener(map, 'click', function () {
                        infoWindow.close();
                    });
                }
            })(marker, content, infoWindow));
        }
    }
}

// Add the given items to the map as either itineraries or points of interest.
function addMapItineraries(map, itineraries) {

    // Enumerate all locations and add images / lines as appropriate.
    for (var i = 0; i < itineraries.length; i++) {
        var itinerary = itineraries[i];

        var content = contentTemplate.replace("[href]", itinerary.url)
            .replace("[src]", itinerary.imageMedia ? cleanMediaUrl(itinerary.imageMedia.url) + "?anchor=center&mode=crop&width=64&height=64" : "")
            .replace("[name]", itinerary.name);

        var infoWindow = new google.maps.InfoWindow({ maxWidth: 200 });

        // Add the itinerary route KML info if available.
        if (itinerary.routeMedia && itinerary.routeMedia.url) {

            // Show an itinerary route if any.
            var route = new google.maps.KmlLayer({
                url: "https://" + window.location.host + itinerary.routeMedia.url,  // must be absolute url here
                map: map
            });

            // Show the info window when a route is clicked 
            google.maps.event.addListener(route, 'click', (function (content, infoWindow, route) {
                return function (event) {
                    infoWindow.setContent(content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, route);
                    google.maps.event.addListener(map, 'click', function () {
                        infoWindow.close();
                    });
                }
            })(content, infoWindow, route));
        }

        // add labelled POIs
        if (itinerary.pois) {
            addMapPOIs(map, itinerary.pois, null, "123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ");
        }
    }
}

// Clean the media urls which may already be annotated with media formatting parameters.
function cleanMediaUrl(url) {
    return url.indexOf("?") == -1 ? url : url.substring(0, url.indexOf("?"));
}